import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import asideModalStore from 'Stores/asideModalStore'
import { classNames as cn } from 'helpers'
import { splitNumberDigits } from 'helpers/math'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import SearchInput from 'components/ContentBox/Global/SearchInput/SearchInput'

const Refunds = ({ translate, transferBonus }) => {
  const {
    modalValues: modalValue,
    changeValue,
    values,
    config,
    check,
    deleteValidField,
  } = asideModalStore // Используем AsideModalStore
  const [selected, setSelected] = useState('')

  const balancesData = {
    company_balances: config.payload?.companies.map((c) => ({
      label: c.company.name,
      value:
        config.type_operation === 'transfer_bonus'
          ? `company_to^^${c.company.id}`
          : `company_to^^${c.id}`,
    })),
    group_balances: config.payload?.groups.map((gr) => ({
      label: `${gr.group.number} - ${gr.group.name}`,
      value: transferBonus
        ? `group_balance_to^^${gr.group.id}`
        : `group_balance_to^^${gr.id}`,
    })),
  }

  config.valid = {
    sum: 'positive',
    comment: 'required',
    ...(config.send && { paymentTo: 'required' }),
  }

  useEffect(() => {
    if (!selected.length) return
    const data = [selected.split('^^')[0], +selected.split('^^')[1]]
    const isGroup = data[0] === 'group_balance_to'
    deleteValidField(isGroup ? 'company_to' : 'group_balance_to')
    changeValue(+data[1], !isGroup ? 'company_to' : 'group_balance_to')
    changeValue(true, 'paymentTo')
  }, [selected])

  const getValue = (val) => {
    const numbers = val.replace(/\s/g, '')
    if (!/^\d*$/.test(numbers)) return
    changeValue(+numbers * 100, 'sum')
  }

  const getClientList = (value) => {
    const client = Array.isArray(value) ? value[0] : value
    changeValue(client?.id, 'to_client_id')
    changeValue(client?.full_name, 'client_name')
  }

  useEffect(() => {
    if (!selected.length) return
    const data = selected.split('^^')
    const isGroup = data[0] === 'group_balance_to'

    deleteValidField(isGroup ? 'company_to' : 'group_balance_to')

    if (isGroup) {
      changeValue(+data[1], 'group_balance_to')
      changeValue(undefined, 'company_to')
    } else {
      changeValue(+data[1], 'company_to')
      changeValue(undefined, 'group_balance_to')
    }

    changeValue(true, 'paymentTo')
  }, [selected])

  return (
    <FormFieldset>
      {config.send && config.type_operation !== 'top_up_bonus' && (
        <FormField>
          <FormLabel>Направление перевода:</FormLabel>
          <SelectCustom
            placeholder='Общий баланс'
            options={[
              ...(config.type_operation !== 'bonus_balance'
                ? [
                    {
                      label: 'Балансы компаний',
                      options: balancesData.company_balances,
                    },
                  ]
                : []),
              {
                label: 'Балансы групп',
                options: balancesData.group_balances,
              },
            ]}
            valueID={selected}
            onChange={(o) => setSelected(o.value)}
            isLoading={!Object.keys(balancesData).length}
            error={check('paymentTo')}
          />
        </FormField>
      )}
      {config.sendToClient && (
        <FormField>
          <FormLabel>{translate.choose_student}:</FormLabel>
          <SearchInput
            link='accounts/clients'
            placeholder={translate.choose_student}
            new_key='full_name'
            getApiList={(result) => result.map((client) => client.profile)}
            backFunction={getClientList}
            initialValue={modalValue.client_name || ''}
            error={check('client')}
          />
        </FormField>
      )}
      <FormField>
        <FormLabel>{translate.amount} ₸:</FormLabel>
        <FormInput>
          <input
            placeholder={translate.amount}
            name='valueInput'
            type='text'
            value={splitNumberDigits(modalValue.sum / 100)}
            onChange={(e) => getValue(e.target.value)}
            className={cn({
              'super-modal__input--center': true,
              'super-modal__input--error': check('sum'),
            })}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>{translate.comment}:</FormLabel>
        <FormInput isError={check('comment')}>
          <textarea
            value={values.comment}
            onChange={(e) => changeValue(e.target.value, 'comment')}
            className='placementTestBox__textarea'
            placeholder={translate.comment}
          />
        </FormInput>
      </FormField>
    </FormFieldset>
  )
}

export default observer(Refunds)
